
// token.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, SilentRequest } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import {ProductOverviewRequest} from "../product-overview/product-overview-request.model";

@Injectable({ providedIn: 'root' })
export class TokenService implements OnDestroy {
  private tokenRefreshInterval: any;

  constructor(
    private readonly authService: MsalService,
    private readonly msalBroadcast: MsalBroadcastService
  ) {
  }

  public initAfterLogin(): void {
    this.msalBroadcast.inProgress$
      .pipe(filter(status => status === InteractionStatus.None))
      .subscribe(() => {
        const account = this.authService.instance.getActiveAccount()
          ?? this.authService.instance.getAllAccounts()[0];

        if (account && !this.tokenRefreshInterval) {
          this.refreshToken().catch(e => console.warn('Initial refresh failed:', e));
          this.startTokenRefreshScheduler();
        }
      });
  }

  async refreshToken(): Promise<void> {
    const account = this.authService.instance.getActiveAccount()
      ?? this.authService.instance.getAllAccounts()[0];

    if (!account) {
      console.info('No active account yet — skipping refresh.');
      return;
    }

    const silentRequest: SilentRequest = {
      scopes: ['GroupMember.Read.All'],
      account,
      forceRefresh: true,
    };

    const tokenResponse = await this.authService.instance.acquireTokenSilent(silentRequest);
    console.info("🔄 updating refreshed token to ProductOverviewRequest.token..");
    ProductOverviewRequest.graphToken = `Bearer ${tokenResponse.accessToken}`;
    ProductOverviewRequest.token = `Bearer ${account.idToken}`;
  }

  startTokenRefreshScheduler(): void {
    if (!this.tokenRefreshInterval) {
      this.tokenRefreshInterval = setInterval(() => {
        console.info("🔄 Auto-refreshing token...");
        this.refreshToken().catch(e => console.warn('Scheduled refresh failed:', e));
      }, 45 * 60 * 1000);
    }
  }

  ngOnDestroy() {
    if (this.tokenRefreshInterval) {
      console.info("🛑 Clearing token refresh interval...");
      clearInterval(this.tokenRefreshInterval);
    }
  }
}
